import { isValidLogoUrl } from '@/utils/isValidLogoUrl';
import styles from './BrandHeader.module.scss';

interface Props {
  url?: string;
  alt: string;
  tabletOnly?: boolean;
  mobileOnly?: boolean;
}

export const HeaderLogo = ({ url, alt, tabletOnly, mobileOnly }: Props) => {
  if (!url || !isValidLogoUrl(url)) {
    return null;
  }

  return (
    <div
      className={`${styles.headerLogo} ${tabletOnly && styles.tabletOnly} ${mobileOnly && styles.mobileOnly}`}
    >
      {isValidLogoUrl(url) && <img src={url} alt={alt} className={styles.logo} />}
    </div>
  );
};
